module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "dedi"
  }, [_vm._v("We respectfully dedicate this book to Ted Alexander and Ed Bearss, two great Civil War historians and authors we lost in 2020.")]), _vm._v(" "), _c('p', {
    staticClass: "dedi1"
  }, [_vm._v("Both were valued mentors, consultants, colleagues, and, most of all, personal friends.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03116e6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Dedication.vue
// module id = 63
// module chunks = 0